import React from 'react'
import styles from './ArticleDetailHeadIntro.module.scss'
import { ArticleHeadProps } from '@/elements/widgets/Article/ArticleDetailHead'
import { Link } from '@/components/Link'
import { getLinkPathname } from '@/utils/urls'
import { Image } from '@/components/Image'
import { getAppConfig } from '@/config/config'

export default function ArticleDetailHeadIntro({
  item,
}: Readonly<{
  item: ArticleHeadProps
}>) {
  const author = item.items[0]?.model?.author
  const config = getAppConfig()
  const basePath = config.basePath

  return (
    <div className={styles.head}>
      {item.items.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {item.model.ad === 'true' && <div className={styles.ad}>Anzeige</div>}
            <div className={styles.intro}>
              {item.model.kicker && <h2 className={styles.kicker}>{item.model.kicker}</h2>}
              <h3 className={styles.headline}>{item.model.headline}</h3>

              {author &&
                (author?.url ? (
                  <Link href={getLinkPathname(author?.url)} className={styles.author}>
                    <Image
                      image={author?.image}
                      alt={author?.image?.filename ?? 'image'}
                      defaultWidth={136}
                      fallbackImage={`${basePath}/assets/autor-fallback.svg`}
                      priority
                    />
                    <span className={styles['author-name']}>{author?.authorRender}</span>
                  </Link>
                ) : (
                  <div className={styles.author}>
                    <Image
                      image={author?.image}
                      alt={author?.image?.filename ?? 'image'}
                      defaultWidth={36}
                      fallbackImage={`${basePath}/assets/autor-fallback.svg`}
                      priority
                    />
                    <span className={styles['author-name']}>{author?.authorRender}</span>
                  </div>
                ))}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
